// v3.18.0 — Carte chat "mes demandes" : vue conversationnelle du moteur
// unique aya_requests, avec CTA vers l'Espace Diaspora.
import { useNavigate } from "react-router-dom";

const STATUS_LABEL = { created: "En attente", accepted: "Acceptée", paid: "Payée", delivered: "Livrée", completed: "Terminée", cancelled: "Annulée" };
const STATUS_COLOR = { created: "#FBBF24", accepted: "#60A5FA", paid: "#34D399", delivered: "#34D399", completed: "#6EE7B7", cancelled: "#F87171" };
const TYPE_EMOJI = { panier: "🧺", facture: "🧾", projet: "💼", investissement: "📈", installation: "🏠", solidarite: "🕊️" };

export default function DiasporaRequestsCard({ items = [] }) {
  const navigate = useNavigate();
  return (
    <div data-testid="diaspora-requests-card" style={{
      marginTop: 10, padding: 14, borderRadius: 14, maxWidth: 460,
      background: "linear-gradient(135deg, rgba(239,199,94,0.08), rgba(96,165,250,0.06))",
      border: "1px solid rgba(239,199,94,0.35)",
    }}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.4, color: "#EFC75E", marginBottom: 8 }}>
        🌍 MES DEMANDES · {items.length}
      </div>
      {items.slice(0, 6).map((r) => (
        <div key={r.request_id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 0", borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
          <span style={{ fontSize: 15 }}>{TYPE_EMOJI[r.type] || "📄"}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.title}</div>
            <div style={{ fontSize: 10.5, opacity: 0.55 }}>
              {r.beneficiary?.name ? `${r.beneficiary.name} · ` : ""}
              {Number.isFinite(Number(r.amount_fcfa)) ? `${Number(r.amount_fcfa).toLocaleString("fr-FR")} F` : ""}
            </div>
          </div>
          <span style={{
            fontSize: 10, fontWeight: 800, padding: "3px 8px", borderRadius: 999, whiteSpace: "nowrap",
            color: STATUS_COLOR[r.status] || "#ccc",
            border: `1px solid ${STATUS_COLOR[r.status] || "#ccc"}44`,
            background: `${STATUS_COLOR[r.status] || "#ccc"}18`,
          }}>{STATUS_LABEL[r.status] || r.status}</span>
        </div>
      ))}
      <button
        data-testid="diaspora-requests-open-dashboard"
        onClick={() => navigate("/diaspora")}
        style={{
          marginTop: 10, width: "100%", padding: "10px 12px", borderRadius: 999,
          border: "none", cursor: "pointer", fontWeight: 800, fontSize: 13,
          background: "linear-gradient(135deg,#EFC75E,#D9A83C)", color: "#1A1206",
        }}
      >🌍 Ouvrir mon Espace Diaspora</button>
    </div>
  );
}
